import { HttpClient } from '@store/base';
import _ from 'lodash';
import querystring from 'query-string';
import {
  GetGoodsBlindPriceRequest,
  GetGoodsBlindPriceResponse,
  GetGoodsCurtainCalculateRequest,
  GetGoodsCurtainCalculateResponse,
  GetGoodsOptionPriceRequest,
  GetGoodsOptionPriceResponse,
  GetGoodsOptionRequest,
  GetGoodsOptionResponse,
} from '../../model';

export class GetGoodsOptionGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsOptionRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsOptionResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v2/goods/${req.gdsNo}/option?${query}`,
    });
  }
}

export class GetGoodsOptionPriceGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsOptionPriceRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsOptionPriceResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/option/price?${query}`,
    });
  }
}

export class GetGoodsCurtainCalculateGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsCurtainCalculateRequest) {
    return await this.httpClient.request<GetGoodsCurtainCalculateResponse>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/curtain/calculate`,
      body: _.omit(req, 'gdsNo'),
    });
  }
}

export class GetGoodsBlindPriceGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsBlindPriceRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsBlindPriceResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/option/blind-price?${query}`,
    });
  }
}
